/**
 * 字体排版配置
 * 基于ERC-1155 Multi-Asset Platform的多元化字体系统
 * 体现多样性、高效率和现代感的视觉特征
 */

// ----------------------------------------------------------------------

function pxToRem(value) {
  return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

// ERC-1155 Multi-Asset Typography - 多元化现代字体配置
const FONT_PRIMARY = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
const FONT_SECONDARY = '"Poppins", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  // ERC-1155 专属多元化标题样式
  h1: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
    lineHeight: 1.2,
    fontSize: pxToRem(40),
    letterSpacing: '-0.015em',
    ...responsiveFontSizes({ sm: 48, md: 56, lg: 64 }),
  },
  h2: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(32),
    letterSpacing: '-0.01em',
    ...responsiveFontSizes({ sm: 36, md: 42, lg: 48 }),
  },
  h3: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(24),
    letterSpacing: '0em',
    ...responsiveFontSizes({ sm: 26, md: 28, lg: 32 }),
  },
  h4: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 22, lg: 24 }),
  },
  h5: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 18, md: 19, lg: 20 }),
  },
  h6: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 500,
    lineHeight: 1.6,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ sm: 17, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.6,
    fontSize: pxToRem(16),
    letterSpacing: '0em',
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 1.6,
    fontSize: pxToRem(14),
    letterSpacing: '0.005em',
  },
  body1: {
    lineHeight: 1.7,
    fontSize: pxToRem(16),
    letterSpacing: '0em',
  },
  body2: {
    lineHeight: 1.6,
    fontSize: pxToRem(14),
    letterSpacing: '0.005em',
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: '0.01em',
  },
  overline: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
    letterSpacing: '0.01em',
    textTransform: 'none',
  },
  // ERC-1155 Multi-Asset Typography Variants
  multi: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(20),
    letterSpacing: '0em',
    textTransform: 'none',
  },
  diverse: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 500,
    lineHeight: 1.4,
    fontSize: pxToRem(18),
    letterSpacing: '0.005em',
  },
  comprehensive: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    letterSpacing: '0.01em',
  },
  batch: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(14),
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },
  efficient: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 500,
    lineHeight: 1.6,
    fontSize: pxToRem(15),
    letterSpacing: '0.005em',
  },
  // Legacy ERC-721 Typography Variants for compatibility
  premium: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
    lineHeight: 1.3,
    fontSize: pxToRem(20),
    letterSpacing: '-0.01em',
    textTransform: 'none',
  },
  luxury: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(18),
    letterSpacing: '0.005em',
    fontStyle: 'italic',
  },
  exclusive: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },
  price: {
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
    fontFeatureSettings: '"tnum"',
  },
};

export default typography;
